<template>
  <vueSelect
      :searchable="true"
      :placeholder="label"
      :options="data[1].values"
      v-model="data[1].selectedValue"
  />
</template>

<script>
const labels = [
  {
    id: 'wos',
    label: 'Weak or strong'
  },
  {
    id: 'code_key',
    label: 'Code Key'
  },
  {
    id: 'star_sign',
    label: 'Star Sign'
  }
];

import vueSelect from 'vue-select'

export default {
  props: ['data'],
  name: "FootprintTableSortingSingle",
  components: {
    vueSelect
  },
  data() {
    return {
      label: ''
    }
  },
  mounted() {
    this.label = labels.find(item => item.id === this.data[0]).label
  }
}
</script>

<style scoped>

</style>